import * as THREE from 'three';

/**
 * Creates a WebGLRenderer attached to the provided canvas element.
 * Shadows, tone-mapping and colour-space are configured here once.
 */
export function createRenderer(canvas: HTMLCanvasElement): THREE.WebGLRenderer {
  const renderer = new THREE.WebGLRenderer({
    canvas,
    antialias: true,
    alpha: false,
  });

  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
  renderer.shadowMap.enabled = true;
  renderer.shadowMap.type = THREE.PCFSoftShadowMap;
  renderer.outputColorSpace = THREE.SRGBColorSpace;
  renderer.toneMapping = THREE.AgXToneMapping;
  renderer.toneMappingExposure = 1;

  return renderer;
}

/**
 * Updates renderer size and camera aspect ratio to match a new container size.
 * Call this whenever the parent container is resized.
 */
export function resizeRenderer(
  renderer: THREE.WebGLRenderer,
  camera: THREE.PerspectiveCamera,
  width: number,
  height: number
): void {
  renderer.setSize(width, height, false); // false = do not set canvas CSS size
  camera.aspect = width / height;
  camera.updateProjectionMatrix();
}
